import React from 'react'
import PropTypes from 'prop-types'
import locale, { langPrefix } from 'shared/i18n/react'
import { FormSwitch } from 'scripts/helpers/AppHelper'
import { resolveCcpaConflict, getCcpaVal as getCcpaValFromStore, setCcpaVal as setCcpaValToStore } from 'scripts/helpers/CcpaHelper'

class RenderCcpa extends React.Component {
  constructor(props) {
    super(props)

    let useLocalValue = false
    const { ccpaDNSOption, ccpaDNSOptionUpdatedAt } = props
    if (typeof ccpaDNSOption !== 'undefined' && typeof ccpaDNSOptionUpdatedAt !== 'undefined') {
      const ccpaDNSOptionDate = new Date(ccpaDNSOptionUpdatedAt * 1000)

      useLocalValue = resolveCcpaConflict({
        initCcpaVal: !ccpaDNSOption,
        initCcpaDate: ccpaDNSOptionDate
      })
    }

    const ccpa = getCcpaValFromStore()

    // Sync ccpa value to api if using local
    if (useLocalValue) {
      this.updateCcpaValueToApi(ccpa)
    }

    this.state = {
      ccpa,
      isCcpaOn: ccpa.value
    }
  }

  getCcpaDescription = () => {
    const descriptionKey = this.state.isCcpaOn ? 'descriptionOptIn' : 'descriptionOptOut'
    const privacyLink = <a href={`${langPrefix()}/privacy`} target="_blank">{locale.ccpaConsent.privacyLinkCta}</a>
    return <div>{locale.formatString(locale.ccpaConsent[descriptionKey], privacyLink)}</div>
  }

  updateCcpaValueToApi = (ccpa) => {
    if (this.props.onChange && typeof this.props.onChange === 'function') {
      this.props.onChange(!ccpa.value)
    }
  }

  onChange = (e) => {
    const newCcpaValue = e.target.checked
    const ccpa = setCcpaValToStore(newCcpaValue)
    this.setState({
      ccpa,
      isCcpaOn: ccpa.value
    })
    this.updateCcpaValueToApi(ccpa)
  }

  render() {
    return <div>
      <div className="row">
        <div className="col small-8">
          <h4>{locale.ccpaConsent.label}</h4>
        </div>
        <div className="col small-3">
          { this.props.message && <span className="info-emphasis success-message">{this.props.message}</span> }
        </div>
        <div className="col small-1">
          <FormSwitch name={name}
            checked={this.state.ccpa.value}
            handleChange={this.onChange}
          />
        </div>
      </div>
      { this.getCcpaDescription() }
    </div>
  }
}

export default RenderCcpa

RenderCcpa.propTypes = {
  onChange: PropTypes.func
}



// WEBPACK FOOTER //
// ./assets/js/lib/Ccpa/RenderCcpa.jsx